export const MAX_LINKS = 6;
export const PAGE_SIZE = 10;